import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { BarIconComponent } from './bar-icon/bar-icon.component';
import { CalendarIconComponent } from './calendar-icon/calendar-icon.component';
import { LineIconComponent } from './line-icon/line-icon.component';
import { PieGridIconComponent } from './pie-grid-icon/pie-grid-icon.component';
import { PieIconComponent } from './pie-icon/pie-icon.component';
import { SummaryIconComponent } from './summary-icon/summary-icon.component';
import { TableIconComponent } from './table-icon/table-icon.component';
import { TileTypeIconComponent } from './tile-type-icon.component';

@NgModule({
   declarations: [
      TileTypeIconComponent,
      BarIconComponent,
      LineIconComponent,
      PieIconComponent,
      PieGridIconComponent,
      SummaryIconComponent,
      TableIconComponent,
      CalendarIconComponent,
   ],
   exports: [
      TileTypeIconComponent,
      BarIconComponent,
      LineIconComponent,
      PieIconComponent,
      PieGridIconComponent,
      SummaryIconComponent,
      TableIconComponent,
      CalendarIconComponent,
   ],
   imports: [CommonModule, MatIconModule],
})
export class TileTypeIconModule {}
